import { containers, gameAssets } from "./gameUI";
import * as PIXI from 'pixi.js'
import { scaleFactor } from "./utility";
import {  Spine } from '@esotericsoftware/spine-pixi-v7'
import gsap from "gsap"
import { config } from "./appConfig";
import { gameData, networkData } from "./data";

export const setJackpotData = (data, userId) => {

        networkData.resetGrandJackpotValue = data[2]?.data?.jackpotBeforeTrigger;
        networkData.resetMajorJackpotValue = data[0]?.data?.jackpotBeforeTrigger;
        networkData.resetMinorJackpotValue = data[1]?.data?.jackpotBeforeTrigger;
    
        networkData.jackpotGrandWin = gameData.grandFlag = data[2]?.data?.won;
        networkData.jackpotMajorWin = gameData.majorFlag = data[0]?.data?.won;
        networkData.jackpotMinorWin = gameData.minorFlag = data[1]?.data?.won;
    
        if(networkData.jackpotGrandWin || networkData.jackpotMajorWin || networkData.jackpotMinorWin) networkData.jackpot = true;
        else networkData.jackpot = false;
    
        if(networkData.jackpotMinorWin) networkData.lastJackpot = 'minor';
        if(networkData.jackpotMajorWin) networkData.lastJackpot = 'major';
        if(networkData.jackpotGrandWin) networkData.lastJackpot = 'grand';
    
        networkData.jackpotGrandWinAmount = data[2]?.data?.wonAmount;
        networkData.jackpotMajorWinAmount = data[0]?.data?.wonAmount;
        networkData.jackpotMinorWinAmount = data[1]?.data?.wonAmount;
    
        networkData.grandCurrentJackpotValue = data[2]?.data?.currentValue;
        networkData.majorCurrentJackpotValue = data[0]?.data?.currentValue;
        networkData.minorCurrentJackpotValue = data[1]?.data?.currentValue;

        if(userId == networkData.userId) showGrandWin(networkData.jackpotGrandWin ? networkData.jackpotGrandWinAmount : networkData.grandCurrentJackpotValue, 4);
        if(userId == networkData.userId) showMajorWin(networkData.jackpotMajorWin ? networkData.jackpotMajorWinAmount : networkData.majorCurrentJackpotValue, 4);
        if(userId == networkData.userId) showMinorWin(networkData.jackpotMinorWin ? networkData.jackpotMinorWinAmount : networkData.minorCurrentJackpotValue, 4);

        if(!networkData.jackpotGrandWin && userId != networkData.userId){
            showGrandWin(networkData.grandCurrentJackpotValue, 4);
        } else if(userId != networkData.userId) {
            showGrandWin(networkData.resetGrandJackpotValue, 4);
        }
       
        if(!networkData.jackpotMajorWin && userId != networkData.userId){
            showMajorWin(networkData.majorCurrentJackpotValue, 4);
        } else if(userId != networkData.userId){
            showMajorWin(networkData.resetMajorJackpotValue, 4)
        }

        if(!networkData.jackpotMinorWin && userId != networkData.userId){
            showMinorWin(networkData.minorCurrentJackpotValue, 4)
        } else if(userId != networkData.userId) {
            showMinorWin(networkData.resetMinorJackpotValue, 4)
        }
}

export const setupJackpotPanel = () => {

   gameAssets.jackpotPanelContainer = new PIXI.Container();
   gameAssets.jackpotPanelContainer.zIndex = 5002
   gameAssets.jackpotPanelContainer.visible = false;

   gameAssets.jackpotPanelSprite = new PIXI.Sprite(PIXI.Assets.get('jackpot-panel'))
   gameAssets.jackpotPanelSprite.anchor.set(0.5);
   gameAssets.jackpotPanelSprite.x = 0;
   gameAssets.jackpotPanelSprite.y = 0;
   gameAssets.jackpotPanelContainer.addChild(gameAssets.jackpotPanelSprite)

   containers.bgContainer.addChild(gameAssets.jackpotPanelContainer)

   const width = gameAssets.jackpotPanelSprite.width

   gameAssets.jackpotPanelContainer.resize = (w, h) => {
       const scale = scaleFactor(gameAssets.gameScreen.width, width)
   
       const normalHeight = h * 0.05
       const topThreshold = (h / 2 - gameAssets.gameScreen.height / 2) * 1
   
       gameAssets.jackpotPanelSprite.x = (w / 2) + (110 *scale)
       gameAssets.jackpotPanelSprite.y = Math.max(normalHeight, topThreshold)
   
    //    gameAssets.jackpotPanelSprite.width = gameAssets.gameScreen.width * 0.8
    //    gameAssets.jackpotPanelSprite.height = height * scale * 0.99
       gameAssets.jackpotPanelSprite.scale.set(scale * 0.8)
     }


     gameAssets.grandJackpotHolder = new PIXI.Sprite(PIXI.Assets.get('grand-panel'))
     gameAssets.grandJackpotHolder.anchor.set(0.5);
     gameAssets.grandJackpotHolder.x = -200
     gameAssets.grandJackpotHolder.y = 20
     gameAssets.grandJackpotHolder.scale.set(0.93)
     gameAssets.jackpotPanelSprite.addChild(gameAssets.grandJackpotHolder);
     
     gameAssets.grandJackpotText = new PIXI.Sprite(PIXI.Assets.get('grand-text'))
     gameAssets.grandJackpotText.x = -200
     gameAssets.grandJackpotText.y = -90
     gameAssets.grandJackpotText.anchor.set(0.5);
     gameAssets.grandJackpotText.scale.set(0.55);
     gameAssets.grandJackpotHolder.addChild(gameAssets.grandJackpotText);
     gameAssets.grandJackpotHolder.sortableChildren = true;

     gameAssets.grandJackpotMask = new PIXI.Graphics();
     gameAssets.grandJackpotMask.beginFill(0xffffff);
     gameAssets.grandJackpotMask.drawRect(-(gameAssets.grandJackpotHolder.width - 60) / 2, -(gameAssets.grandJackpotHolder.height - 60) / 2, gameAssets.grandJackpotHolder.width - 60, gameAssets.grandJackpotHolder.height - 60);  // Adjust position & size
     gameAssets.grandJackpotMask.endFill();
     gameAssets.grandJackpotHolder.addChild(gameAssets.grandJackpotMask);

     gameAssets.grandJackpotSpine = Spine.from({ skeleton: "jackpotPanelSpine", atlas: "jackpotPanelSpineAtlas" });
     gameAssets.grandJackpotSpine.x = config.logicalWidth / 2 - 615
     gameAssets.grandJackpotSpine.y = config.logicalHeight / 2 - 144
     gameAssets.grandJackpotSpine.scale.set(1)
     gameAssets.grandJackpotHolder.addChild(gameAssets.grandJackpotSpine);
    //  gameAssets.grandJackpotSpine.state.setAnimation(1, "grand_anticipation", true);
     gameAssets.grandJackpotSpine.zIndex = 1
     gameAssets.grandJackpotText.zIndex = 2

     gameAssets.majorJackpotHolder = new PIXI.Sprite(PIXI.Assets.get('major-panel'))
     gameAssets.majorJackpotHolder.anchor.set(0.5);
     gameAssets.majorJackpotHolder.x = 415
     gameAssets.majorJackpotHolder.y = -55
     gameAssets.grandJackpotHolder.scale.set(1)
     gameAssets.jackpotPanelSprite.addChild(gameAssets.majorJackpotHolder);
     gameAssets.majorJackpotHolder.sortableChildren = true;
     
     gameAssets.majorJackpotText = new PIXI.Sprite(PIXI.Assets.get('major-text'))
     gameAssets.majorJackpotText.x = -90
     gameAssets.majorJackpotText.y = -43
     gameAssets.majorJackpotText.anchor.set(0.5);
     gameAssets.majorJackpotText.scale.set(1);
     gameAssets.majorJackpotHolder.addChild(gameAssets.majorJackpotText);

     gameAssets.majorJackpotMask = new PIXI.Graphics();
     gameAssets.majorJackpotMask.beginFill(0xffffff);
     gameAssets.majorJackpotMask.drawRect(-(gameAssets.majorJackpotHolder.width - 50) / 2, -(gameAssets.majorJackpotHolder.height - 50) / 2, gameAssets.majorJackpotHolder.width - 50, gameAssets.majorJackpotHolder.height - 50);  // Adjust position & size
     gameAssets.majorJackpotMask.endFill();
     gameAssets.majorJackpotHolder.addChild(gameAssets.majorJackpotMask);
     
     gameAssets.majorJackpotSpine = Spine.from({ skeleton: "jackpotPanelSpine", atlas: "jackpotPanelSpineAtlas" });
     gameAssets.majorJackpotSpine.x = -495
     gameAssets.majorJackpotSpine.y = 1210
     gameAssets.majorJackpotSpine.scale.set(1)
     gameAssets.majorJackpotHolder.addChild(gameAssets.majorJackpotSpine);
//   gameAssets.majorJackpotSpine.state.setAnimation(1, "major_anticipation", true);
     gameAssets.majorJackpotSpine.zIndex = 1
     gameAssets.majorJackpotText.zIndex = 2


     gameAssets.minorJackpotHolder = new PIXI.Sprite(PIXI.Assets.get('minor-panel'))
     gameAssets.minorJackpotHolder.anchor.set(0.5);
     gameAssets.minorJackpotHolder.x = 410
     gameAssets.minorJackpotHolder.y = 55
     gameAssets.minorJackpotHolder.scale.set(1.02)
     gameAssets.jackpotPanelSprite.addChild(gameAssets.minorJackpotHolder);
     gameAssets.minorJackpotHolder.sortableChildren = true;
     
     gameAssets.minorJackpotText = new PIXI.Sprite(PIXI.Assets.get('minor-text'))
     gameAssets.minorJackpotText.x = -90
     gameAssets.minorJackpotText.y = -43
     gameAssets.minorJackpotText.anchor.set(0.5);
     gameAssets.minorJackpotText.scale.set(1);
     gameAssets.minorJackpotHolder.addChild(gameAssets.minorJackpotText);
    
     gameAssets.minorJackpotMask = new PIXI.Graphics();
     gameAssets.minorJackpotMask.beginFill(0xffffff);
     gameAssets.minorJackpotMask.drawRect(-(gameAssets.minorJackpotHolder.width - 50) / 2, -(gameAssets.minorJackpotHolder.height - 50) / 2, gameAssets.minorJackpotHolder.width - 50, gameAssets.minorJackpotHolder.height - 50);  // Adjust position & size
     gameAssets.minorJackpotMask.endFill();
     gameAssets.minorJackpotHolder.addChild(gameAssets.minorJackpotMask);
     
     gameAssets.minorJackpotSpine = Spine.from({ skeleton: "jackpotPanelSpine", atlas: "jackpotPanelSpineAtlas" });
     gameAssets.minorJackpotSpine.x = -495
     gameAssets.minorJackpotSpine.y = 1100
     gameAssets.minorJackpotSpine.scale.set(1)
     gameAssets.minorJackpotHolder.addChild(gameAssets.minorJackpotSpine);
 //  gameAssets.minorJackpotSpine.state.setAnimation(1, "minor_anticipation", true);
     gameAssets.minorJackpotSpine.zIndex = 1
     gameAssets.minorJackpotText.zIndex = 2
}

export const hideGrandWinSpine = () => {
    gameAssets.grandJackpotSpine.visible = false;
    gameAssets.grandJackpotSpine.state.setAnimation(1, "grand_win", false);
}

export const hideMajorWinSpine = () => {
    gameAssets.majorJackpotSpine.visible = false;
    gameAssets.majorJackpotSpine.state.setAnimation(1, "major_win", false);
}

export const hideMinorWinSpine = () => {
    gameAssets.minorJackpotSpine.visible = false;
    gameAssets.minorJackpotSpine.state.setAnimation(1, "minor_win", false);
}

const hideAllWinSpines = () => {
    gameAssets.grandJackpotSpine.visible = false;
    gameAssets.grandJackpotSpine.state.setAnimation(1, "grand_win", false);
    gameAssets.majorJackpotSpine.visible = false;
    gameAssets.majorJackpotSpine.state.setAnimation(1, "major_win", false);
    gameAssets.minorJackpotSpine.visible = false;
    gameAssets.minorJackpotSpine.state.setAnimation(1, "minor_win", false);
}

export const hideAnticipationAnimation = () => {
    gameAssets.grandJackpotSpine.visible = false;
    gameAssets.majorJackpotSpine.visible = false;
    gameAssets.minorJackpotSpine.visible = false;
}

export const showGrandWin = (winAmount = 1000000, duration = 5, animation = true) => {
    gameAssets.targetGrandWin = winAmount;
    countUpGrand(winAmount, duration)
    splitGrandNumberToDigits(gameAssets.grandWinDisplayAmount);
    
    if (winAmount > 0 && animation) {
        gameAssets.grandJackpotSpine.state.setAnimation(1, "grand_anticipation", true);
        gameAssets.grandJackpotSpine.visible = true;
    }
    // setTimeout(() => {
    //     gameAssets.splitGrandNumberToDigits(winAmount);
    // }, 100);
}

const clearGrandArray = () => {
    gameAssets.grandJackpotNumberArray.forEach(element => {
        gameAssets.grandJackpotHolder.removeChild(element);
    })
    gameAssets.grandJackpotNumberArray = [];
    gameAssets.grandJackpotNumberArray.length = 0;
}

export const showMajorWin = (winAmount = 1000000, duration = 5, animation = true) => {
    gameAssets.targetMajorWin = winAmount;
    countUpMajor(winAmount, duration)
    splitMajorNumberToDigits(gameAssets.majorWinDisplayAmount);
    if (winAmount > 0 && animation) {
        gameAssets.majorJackpotSpine.state.setAnimation(1, "major_anticipation", true);
        gameAssets.majorJackpotSpine.visible = true;
    }
    // setTimeout(() => {
    //     gameAssets.splitGrandNumberToDigits(winAmount);
    // }, 100);
}

const clearMajorArray = () => {
    gameAssets.majorJackpotNumberArray.forEach(element => {
        gameAssets.majorJackpotHolder.removeChild(element);
    })
    gameAssets.majorJackpotNumberArray = [];
    gameAssets.majorJackpotNumberArray.length = 0;
}

export const showMinorWin = (winAmount = 1000000, duration = 5, animation = true) => {
    gameAssets.targetMinorWin = winAmount;
    countUpMinor(winAmount, duration)
    splitMinorNumberToDigits(gameAssets.minorWinDisplayAmount);
    if (winAmount > 0 && animation) {
        gameAssets.minorJackpotSpine.state.setAnimation(1, "minor_anticipation", true);
        gameAssets.minorJackpotSpine.visible = true
    }
}

const countUpGrand = (targetValue, duration) => {
    let obj = { value: gameAssets.grandWinDisplayAmount }; // Temporary object for animation

    gsap.to(obj, {
        value: targetValue,
        duration: duration,
        ease: "power2.out",
        onUpdate: () => {
            let decimalCount = (targetValue % 1 !== 0) ? 2 : 0; // Check if target has decimals

            gameAssets.grandWinDisplayAmount = obj.value.toFixed(decimalCount); // Format accordingly

            //console.log(grandWinDisplayAmount); // Log updated value
        }
    });
};

const clearMinorArray = () => {
    gameAssets.minorJackpotNumberArray.forEach(element => {
        gameAssets.minorJackpotHolder.removeChild(element);
    })
    gameAssets.minorJackpotNumberArray = [];
    gameAssets.minorJackpotNumberArray.length = 0;
}

const countUpMajor = (targetValue, duration) => {
    let obj = { value: gameAssets.majorWinDisplayAmount }; // Temporary object for animation

    gsap.to(obj, {
        value: targetValue,
        duration: duration,
        ease: "power2.out",
        onUpdate: () => {
            let decimalCount = (targetValue % 1 !== 0) ? 2 : 0; // Check if target has decimals

           gameAssets.majorWinDisplayAmount = obj.value.toFixed(decimalCount); // Format accordingly

            // //console.log(grandWinDisplayAmount); // Log updated value
        }
    });
};

const countUpMinor = (targetValue, duration) => {
    let obj = { value: gameAssets.minorWinDisplayAmount }; // Temporary object for animation

    gsap.to(obj, {
        value: targetValue,
        duration: duration,
        ease: "power2.out",
        onUpdate: () => {
            let decimalCount = (targetValue % 1 !== 0) ? 2 : 0; // Check if target has decimals

           gameAssets.minorWinDisplayAmount = obj.value.toFixed(decimalCount); // Format accordingly

            //  //console.log(grandWinDisplayAmount); // Log updated value
        }
    });
};

export const resetPanel = () => {
    // networkData.grandCurrentJackpotValue = networkData.resetGrandJackpotValue;
    // networkData.majorCurrentJackpotValue = networkData.resetMajorJackpotValue;
    // networkData.minorCurrentJackpotValue = networkData.resetMinorJackpotValue;
    showGrandWin(gameData.grandFlag ? networkData.grandCurrentJackpotValue : networkData.resetGrandJackpotValue, 0.1 , false)
    showMajorWin(gameData.majorFlag ? networkData.majorCurrentJackpotValue : networkData.resetMajorJackpotValue, 0.1 , false)
    showMinorWin(gameData.minorFlag ? networkData.minorCurrentJackpotValue : networkData.resetMinorJackpotValue, 0.1 , false)

    gameData.grandFlag = gameData.minorFlag = gameData.majorFlag = false;
    // grandWinDisplayAmount = 0;
    // majorWinDisplayAmount = 0;
    // minorWinDisplayAmount = 0;
    // this.grandJackpotNumberArray = [];
    // this.majorJackpotNumberArray = [];
    // this.minorJackpotNumberArray = [];
    hideAllWinSpines();
    }

export const showMinorWinSpine = () => {
    gameAssets.minorJackpotSpine.visible = true;
    gameAssets.minorJackpotSpine.state.setAnimation(1, "minor_win", true);
}

export const showMajorWinSpine = () => {
    gameAssets.majorJackpotSpine.visible = true;
    gameAssets.majorJackpotSpine.state.setAnimation(1, "major_win", true);
}

export const showGrandWinSpine = () => {
    gameAssets.grandJackpotSpine.visible = true;
    gameAssets.grandJackpotSpine.state.setAnimation(1, "grand_win", true);
}

const checkNumberMatch = (array, targetValue) => {
    const numberString = array.map(digitText => digitText.text).join(""); // Join digits
    const parsedNumber = parseFloat(numberString.replace(/,/g, '')); // Convert to number
    targetValue = Math.round(targetValue * 100) / 100; // Round targetValue to 2 decimal places

    return Math.abs(parsedNumber - targetValue) < 0.00001; // Use a small threshold
};

const playDownAnimation6 = (array, index) => {
    gsap.to(array[index], {
        y: array[index].y + 50,
        duration: 0.07,
        onComplete: () => {
            if (array[index + 1])
                playDownAnimation6(array, index + 1);
            else
                splitMinorNumberToDigits(gameAssets.minorWinDisplayAmount)
        }
    })
}

const playDownAnimation5 = (array, index) => {
    array[index].y = -90

    gsap.to(array[index], {
        y: array[index].y + 85,
        duration: 0.07,
        onComplete: () => {
            if (array[index + 1]) {
                playDownAnimation5(array, index + 1);
            }
            else {
                if (checkNumberMatch(array, gameAssets.targetMinorWin)) {
                    // minorWinDisplayAmount = 0;
                    gameAssets.minorJackpotSpine.state.setAnimation(1, "minor_anticipation", false);
                    gameAssets.minorJackpotSpine.visible = false;
                    if (networkData.jackpotMinorWinAmount && !gameData.firstScratchDone) {
                        // showMinorWinSpine();
                    }
                    return;
                }
                setTimeout(() => {
                    playDownAnimation6(array, 0);
                }, gameAssets._pauseDuration);
            }
        }
    })
}

const splitMinorNumberToDigits = (number) => {
        if (number === null || number === undefined || isNaN(number)) {
            return;
        }
    
        if (gameAssets.minorJackpotNumberArray.length) clearMinorArray();
    
        gameAssets.minorJackpotNumberArray = []; // Reset properly
    
        // Ensure at least "0" is visible
        let numStr = number.toString().trim();
        let parts = numStr.split('.'); // Separate integer and decimal parts
        let integerPart = parts[0];
        let decimalPart = parts.length > 1 ? '.' + parts[1] : '';
    
        let splitDigits = integerPart.split('').reverse();
        let formatted = [];
    
        for (let i = 0; i < splitDigits.length; i++) {
            if (i > 0 && i % 3 === 0) {
                formatted.push(',');
            }
            formatted.push(splitDigits[i]);
        }
    
        numStr = formatted.reverse().join('') + decimalPart;
    
        const numbers = numStr.split("").map(digit => {
            return digit === "." || digit === "," ? digit : isNaN(digit) ? 0 : digit; // Keep "." and "," as they are
        });
    
        const digitSpacing = 28; // Space between digits
        const totalWidth = numbers.length * digitSpacing; // Total width of the number
        const startX = -(totalWidth / 2) + digitSpacing; // Start position for centering
    
        // Remove existing currency symbol if it exists
        if (gameAssets.currencySymbol3) {
            gameAssets.minorJackpotHolder.removeChild(gameAssets.currencySymbol3);
            gameAssets.currencySymbol3.destroy(); // Properly clean up the old symbol
        }
    
        // Create a single "₱" symbol
        gameAssets.currencySymbol3 = new PIXI.BitmapText("₱", {
            fontName: 'jackpot_bitmap-fnt-export',
            fontSize: 10,
            align: 'center'
        });
    
        gameAssets.currencySymbol3.anchor.set(0.5);
        gameAssets.currencySymbol3.y = -5;
        gameAssets.currencySymbol3.x = startX - digitSpacing - 8; // Position it before the first digit
        gameAssets.minorJackpotHolder.addChild(gameAssets.currencySymbol3);
    
        numbers.forEach((element, index) => {
            const digitText = new PIXI.BitmapText(element.toString(), {
                fontName: 'jackpot_bitmap-fnt-export',
                fontSize: 10,
                align: 'center',
                letterSpacing: 0,
            });
    
            digitText.anchor.set(0.5);
            digitText.y = -20;
            digitText.x = startX + index * digitSpacing; // Adjust X to center the digits
    
            gameAssets.minorJackpotHolder.addChild(digitText);
            gameAssets.minorJackpotNumberArray[index] = digitText;
    
            if (gameAssets.minorJackpotMask) {
                gameAssets.minorJackpotNumberArray[index].mask = gameAssets.minorJackpotMask;
            } else {
            }
        });
    
        playDownAnimation5(gameAssets.minorJackpotNumberArray, 0);
    }

   const playDownAnimation4 = (array, index) => {
        gsap.to(array[index], {
            y: array[index].y + 100,
            duration: 0.07,
            onComplete: () => {
                if (array[index + 1])
                    playDownAnimation4(array, index + 1);
                else
                    splitMajorNumberToDigits(gameAssets.majorWinDisplayAmount)
            }
        })
    }

  const  playDownAnimation3 = (array, index, offsetY, pauseY) => {
        array[index].y = -40

        gsap.to(array[index], {
            y: array[index].y + 35,
            duration: 0.07,
            onComplete: () => {
                if (array[index + 1]) {
                    playDownAnimation3(array, index + 1);
                }
                else {
                    if (checkNumberMatch(array, gameAssets.targetMajorWin)) {
                        //   majorWinDisplayAmount = 0;
                        gameAssets.majorJackpotSpine.state.setAnimation(1, "major_anticipation", false);
                        gameAssets.majorJackpotSpine.visible = false;
                        if (networkData.jackpotMajorWinAmount && !gameData.firstScratchDone) {
                            // showMajorWinSpine();
                        }
                        return;
                    }
                    setTimeout(() => {
                        playDownAnimation4(array, 0);
                    }, gameAssets._pauseDuration);
                }
            }
        })
    }

const splitMajorNumberToDigits = (number) => {
        if (number === null || number === undefined || isNaN(number)) {
            return;
        }
    
        if (gameAssets.majorJackpotNumberArray.length) clearMajorArray();
    
        gameAssets.majorJackpotNumberArray = []; // Reset properly
    
        // Ensure at least "0" is visible
        let numStr = number.toString().trim();
        let parts = numStr.split('.'); // Separate integer and decimal parts
        let integerPart = parts[0];
        let decimalPart = parts.length > 1 ? '.' + parts[1] : '';
    
        let splitDigits = integerPart.split('').reverse();
        let formatted = [];
    
        for (let i = 0; i < splitDigits.length; i++) {
            if (i > 0 && i % 3 === 0) {
                formatted.push(',');
            }
            formatted.push(splitDigits[i]);
        }
    
        numStr = formatted.reverse().join('') + decimalPart;
    
        const numbers = numStr.split("").map(digit => {
            return digit === "." || digit === "," ? digit : isNaN(digit) ? 0 : digit; // Keep "." and "," as they are
        });
    
        const digitSpacing = 28; // Space between digits
        const totalWidth = numbers.length * digitSpacing; // Total width of the number
        const startX = -(totalWidth / 2) + digitSpacing; // Start position for centering
    
        // Remove existing currency symbol if it exists
        if (gameAssets.currencySymbol2) {
            gameAssets.majorJackpotHolder.removeChild(gameAssets.currencySymbol2);
            gameAssets.currencySymbol2.destroy(); // Properly clean up the old symbol
        }
    
        // Create a single "₱" symbol
        gameAssets.currencySymbol2 = new PIXI.BitmapText("₱", {
            fontName: 'jackpot_bitmap-fnt-export',
            fontSize: 10,
            align: 'center'
        });
    
        gameAssets.currencySymbol2.anchor.set(0.5);
        gameAssets.currencySymbol2.y = -7;
        gameAssets.currencySymbol2.x = startX - digitSpacing - 8; // Position it before the first digit
        gameAssets.majorJackpotHolder.addChild(gameAssets.currencySymbol2);
    
        numbers.forEach((element, index) => {
            const digitText = new PIXI.BitmapText(element.toString(), {
                fontName: 'jackpot_bitmap-fnt-export',
                fontSize: 10,
                align: 'center',
                letterSpacing: 0,
            });
    
            digitText.anchor.set(0.5);
            digitText.y = -20;
            digitText.x = startX + index * digitSpacing; // Adjust X to center the digits
    
            gameAssets.majorJackpotHolder.addChild(digitText);
            gameAssets.majorJackpotNumberArray[index] = digitText;
    
            if (gameAssets.majorJackpotMask) {
                gameAssets.majorJackpotNumberArray[index].mask = gameAssets.majorJackpotMask;
            } else {
                // console.error("Mask is not defined before assignment");
            }
        });
    
        playDownAnimation3(gameAssets.majorJackpotNumberArray, 0);
}

const playDownAnimation2 = (array, index) => {
    gsap.to(array[index], {
        y: array[index].y + 100,
        duration: 0.07,
        onComplete: () => {
            if (array[index + 1])
                playDownAnimation2(array, index + 1);
            else
                splitGrandNumberToDigits(gameAssets.grandWinDisplayAmount)
        }
    })
}

const playDownAnimation1 = (array, index, offsetY, pauseY) => {
    array[index].y = -100

    gsap.to(array[index], {
        y: array[index].y + 85,
        duration: 0.07,
        onComplete: () => {
            if (array[index + 1]) {
                playDownAnimation1(array, index + 1);
            }
            else {
                //console.log(this.targetGrandWin)
                if (checkNumberMatch(array, gameAssets.targetGrandWin)) {
                    console.log("true ")
                    // grandWinDisplayAmount = 0;
                    gameAssets.grandJackpotSpine.state.setAnimation(1, "grand_anticipation", false);
                    gameAssets.grandJackpotSpine.visible = false;                    
                    if (networkData.jackpotGrandWinAmount && !gameData.firstScratchDone && gameData.userId == networkData.userId) {
                        // showGrandWinSpine();
                    }
                    return;
                }
                //console.log(this.targetGrandWin)
                setTimeout(() => {
                    playDownAnimation2(array, 0);
                }, gameAssets._pauseDuration);
            }
        }
    })
}

const splitGrandNumberToDigits = (number) => {
        if (number === null || number === undefined || isNaN(number)) {
            // console.error("Invalid number input:", number);
            return;
        }
    
        if (gameAssets.grandJackpotNumberArray.length) clearGrandArray();
    
        gameAssets.grandJackpotNumberArray = []; // Reset properly
    
        // Ensure at least "0" is visible
        let numStr = number.toString().trim();
        let parts = numStr.split('.'); // Separate integer and decimal parts
        let integerPart = parts[0];
        let decimalPart = parts.length > 1 ? '.' + parts[1] : '';
        
        let splitDigits = integerPart.split('').reverse();
        let formatted = [];
        
        for (let i = 0; i < splitDigits.length; i++) {
            if (i > 0 && i % 3 === 0) {
                formatted.push(',');
            }
            formatted.push(splitDigits[i]);
        }
        
        numStr = formatted.reverse().join('') + decimalPart;
    
        const numbers = numStr.split("").map(digit => {
            return digit === "." || digit === "," ? digit : isNaN(digit) ? 0 : digit; // Keep "." and "," as they are
        });
    
        const digitSpacing = 55; // Space between digits
        const totalWidth = numbers.length * digitSpacing; // Total width of the number
        const startX = -(totalWidth / 2) + digitSpacing; // Start position for centering
    
        // Remove existing currency symbol if it exists
        if (gameAssets.currencySymbol) {
            gameAssets.grandJackpotHolder.removeChild(gameAssets.currencySymbol);
            gameAssets.currencySymbol.destroy(); // Properly clean up the old symbol
        }
    
        // Create a single "₱" symbol
        gameAssets.currencySymbol = new PIXI.BitmapText("₱", {
            fontName: 'jackpot_bitmap-fnt-export',
            fontSize: 19,
            align: 'center'
        });

        
    
        gameAssets.currencySymbol.anchor.set(0.5);
        gameAssets.currencySymbol.y = -20;
        gameAssets.currencySymbol.x = startX - digitSpacing - 8; // Position it before the first digit
        gameAssets.grandJackpotHolder.addChild(gameAssets.currencySymbol);
    
        numbers.forEach((element, index) => {
            const digitText = new PIXI.BitmapText(element.toString(), {
                fontName: 'jackpot_bitmap-fnt-export',
                fontSize: 19,
                align: 'center',
                letterSpacing: 0,
            });
    
            digitText.anchor.set(0.5);
            digitText.y = -20;
            digitText.x = startX + index * digitSpacing; // Adjust X to center the digits
    
            gameAssets.grandJackpotHolder.addChild(digitText);
            gameAssets.grandJackpotNumberArray[index] = digitText;
    
            if (gameAssets.grandJackpotMask) {
                gameAssets.grandJackpotNumberArray[index].mask = gameAssets.grandJackpotMask;
            } else {
                // console.error("Mask is not defined before assignment");
            }
        });
    
        playDownAnimation1(gameAssets.grandJackpotNumberArray, 0);
    }
